import React, { useState } from "react";
import "../../stylesheet/_grid.scss";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { addSubscriberMailchimp } from "../../api/mailchimp";

const FooterNewsletter: React.FC = () => {
  const { t, ready } = useTranslation();
  // const checkLanguage = (lang: string) => {
  //   if (i18n.language == lang) return true;
  //   return false;
  // };
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [engCheck, setEngCheck] = useState<boolean>(true);
  const [arCheck, setArCheck] = useState<boolean>(true);
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleNewsletter = (e: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);

    e.preventDefault();
    //console.log(name, email, engCheck, arCheck);

    // const payload = {
    //   merge_fields: {
    //     name: name,
    //   },
    //   interests: {
    //     engCheck: engCheck,
    //     arCheck: arCheck,
    //   },
    //   email: email,
    //   status: "subscribed",
    // };

    const payload = {
      name: name,
      email: email,
      arCheck: arCheck,
      engCheck: engCheck,
    };

    // console.log("Payload: ", payload);
    console.log("Payload: ", JSON.stringify(payload));

    addSubscriberMailchimp(JSON.stringify(payload)).then(() => {
      setSuccess(true);
      setLoading(false);
    });
  };

  const successHandler = () => {
    if (success) {
      //reset the fields
      setTimeout(() => {
        setSuccess(false);
        setName("");
        setEmail("");
        setArCheck(true);
        setEngCheck(true);
      }, 3000);
      return <p className="p2">{t("misc.thank-you")}</p>;
    }
    return (
      <div className="flex-r flex-s-between footer-radios">
        <label className="flex-r" style={{ width: "40%" }}>
          <input
            readOnly
            type="radio"
            name="english"
            value="english"
            checked={engCheck}
            onClick={() => setEngCheck(!engCheck)}
          />

          <span className="p2">English</span>
        </label>
        <label className="flex-r" style={{ width: "30%" }}>
          <input
            readOnly
            type="radio"
            name="arabic"
            value="arabic"
            checked={arCheck}
            onClick={() => setArCheck(!arCheck)}
          />
          <span className="p2">العربية</span>
        </label>
      </div>
    );
  };

  return (
    <div className="flex mb-1">
      {" "}
      <h5>{t("footer.zenewsletter")}</h5>
      <p className="p2" style={{ marginTop: "0" }}>
        {t("footer.signup")}
      </p>
      <form onSubmit={handleNewsletter}>
        <input
          type="text"
          value={name}
          className="form-control my-1 footer-input"
          placeholder={t("input.name")}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="email"
          value={email}
          className="form-control my-1 footer-input"
          placeholder={t("input.email")}
          // pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {successHandler()}
        <button
          disabled={loading}
          type="submit"
          className="btn btn-second cta col-12 col-md-6 col-lg-5"
        >
          {loading
            ? `${t("button.subscribing")}`
            : ` ${ready ? t("button.subscribe") : <Skeleton width={80} />}`}
        </button>
      </form>
    </div>
  );
};

export default FooterNewsletter;
